import { useLayoutEffect as o, useEffect as t } from "react";
import { isBrowser as e } from "./atoms-v2921.js";
const s = e ? o : t;
export {
  s as useIsomorphicLayoutEffect
};
